module.exports = "/images/9a66df8-mavric_logo_new.png";